<template>
  <div class="container" :style="{height:height, top:top }" layout="column spread-left">
    <div v-for="i in flashCount" class="w100" layout="row center-left">
      <div class="flash" self="left"><img src="/static/images/flash.png" /></div>
      <div class="flash flash-right" self="right"><img src="/static/images/flash.png" /></div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "lightning",
    props: ['height', 'flashCount'],
    data() {
      return {
        scroll: 0,
        top: '0px',
        count: 1

      }

    },
    methods: {},
    mounted() {


      // this.scrollTop = window.pageYOffset;
      // this.offset = 50;
      //
      // const scroller = () => {
      //   this.scroll = this.scrollTop - window.pageYOffset;
      //   this.top = (this.offset += this.scroll * 0.5) + 'px';
      //   this.scrollTop = window.pageYOffset;
      //   this.rafId = requestAnimationFrame(scroller);
      // };
      //
      // scroller();
      // this.rafId = requestAnimationFrame(scroller);

    },
    destroyed() {
      cancelAnimationFrame(this.rafId);
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0px;
    /*background-color: blueviolet;*/
    z-index: -1;
    overflow: hidden;



  }

  .flash-right {
    transform: scaleX(-1);
  }

  .flash {
    opacity: 0.9;
    width: 50vw;
    max-width: 500px;
    /*mix-blend-mode: color-dodge;*/
  }

  .flash img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Lightning.vue